import { productIdFormat, supplierIdFormat } from "@redotech/redo-ids/ids";
import * as z from "zod";

export const removeProductsFromSupplier = {
  name: "removeProductsFromSupplier" as const,
  input: z.object({
    supplierId: supplierIdFormat.schema,
    productIds: z.array(productIdFormat.schema),
  }),
  output: z.object({ removedCount: z.number().int() }),
};
